'use client';

import { useEffect } from 'react';
import { logger } from '@/lib/logger';
import { ErrorDisplay } from '@/components/error-display';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    logger.error('Global error boundary caught:', error);
  }, [error]);

  return (
    <html lang="en-AU">
      <body className="min-h-screen bg-background flex items-center justify-center p-4">
        <ErrorDisplay
          title="Application Error"
          message="A critical error occurred while loading the application. We're working to fix this issue."
          error={error}
          onRetry={() => window.location.reload()}
          showContactSupport={true}
        />
      </body>
    </html>
  );
}